import isNil from 'lodash/isNil';

import assert from './assert';

export default (value, message) =>
  assert(isNil(value), message || `Expected null or undefined, got '${value}'`);
